import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { json3n35pf5np6si4 as json } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/json.mjs';
import com_zegreatrob_coupling_client_components_external_fitty_fitty_y6aocd from 'fitty';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function fitty(_this__u8e3s4, maxFontHeight, minFontHeight, multiLine) {
  if (equals(globalThis['IS_JSDOM'], true)) {
    return Unit_instance;
  }
  // Inline function 'kotlin.js.unsafeCast' call
  com_zegreatrob_coupling_client_components_external_fitty_fitty_y6aocd(_this__u8e3s4, json([to('maxSize', maxFontHeight), to('minSize', minFontHeight), to('multiLine', multiLine)]));
}
//region block: exports
export {
  fitty as fitty56sdk9q03su9,
};
//endregion

//# sourceMappingURL=ReactFittyHelper.mjs.map
